$(() => {
  const tabsSection = $(".bs-section--common-button-tab-section .bs-column .bs-pro-button"); // getting all tabs button classes
  if (tabsSection.length != 0) {
    $(tabsSection).first().addClass("active"); // active first tab
    $("section[class*='bs-section--map-tab-']").not(".bs-section--map-tab-1").hide(); // active first tab related sections
    $(tabsSection).on("click", (e) => {
      e.preventDefault();
      $(tabsSection).removeClass("active"); // remove all buttons active class
      $(e.currentTarget).addClass("active"); // add active class to clicked tab button
      const clickedIndex = $(e.currentTarget).index() + 1; // addition one to make same class name
      $("section[class*='bs-section--map-tab-']").hide(); // hide all tabs
      $(`.bs-section--map-tab-${clickedIndex}`).show(); // show clicked index related tab sections

      if ($('.timeline-inner').length) {
        if ($('.timeline-inner').height() > $('.timeline').height()) {
          $('.timeline-wrapper').find('.button-wrapper').addClass('hide');
        } else {
          $('.timeline-wrapper').find('.button-wrapper').removeClass('hide');
        }
      }

    });
  }
});
